// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import LabeledCurrency from '../../../../shared/components/labeled-currency/index';
import LabeledSmartFormLink from '../../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import LabeledString from '../../../../shared/components/labeled-string/index';
import MassProcessInvoice from '@deere/cps-it.warranty-model-factory/lib/invoice-mass-process';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';

const MassProcessInvoiceItem = props =>
    <section className='mass-process-invoice'>
        <div className='invoice-request-row'>
            <LabeledString
                className='lost-two-column'
                data={props.invoice.invoiceRequestNumber}
                label='INVOICE_REQUEST'
            />
            <span>{props.invoice.status.value}</span>
        </div>
        <div className='row'>
            <LabeledString
                className='lost-two-column'
                data={buildDealer(props.dealer)}
                label='DEALER_LOCATION'
            />
            <LabeledCurrency
                data={props.invoice.netAmount}
                label='NET_AMOUNT'
            />
        </div>
        <div className='row'>
            <LabeledString
                className='lost-two-column'
                data={buildDate(props.invoice.requestDate)}
                label='REQUESTED'
            />
            <LabeledCurrency
                data={props.invoice.taxAmount}
                label='TAX'
            />
        </div>
        <div className='row'>
            <div className='spacer lost-two-column'/>
            <LabeledCurrency
                data={props.invoice.totalAmount}
                label='TOTAL_AMOUNT'
            />
        </div>
        <div className='row'>
            {props.isInvoiceNumberVisible &&
                <LabeledString
                    className='invoice-number'
                    data={props.invoice.dealerInvoiceNumber}
                    label='INVOICE_NUMBER'
                />
            }
            <LabeledSmartFormLink
                displayText={props.invoice.invoiceRequestNumber}
                formName='DEALER_INVOICE'
                label='REQUEST_FORM'
                objectId={props.invoice.invoiceRequestNumber}
            />
            {props.invoice.invoiceSentDate === null ?
                null :
                <LabeledString
                    className='invoice-sent'
                    data={buildDate(props.invoice.invoiceSentDate)}
                    label='INVOICE_SENT'
                />
            }
        </div>
    </section>;

MassProcessInvoiceItem.displayName = 'MassProcessInvoiceItem';
MassProcessInvoiceItem.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired,
    invoice: PropTypes.instanceOf(MassProcessInvoice).isRequired,
    isInvoiceNumberVisible: PropTypes.bool.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default MassProcessInvoiceItem;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/mass-process-invoice/mass-process-invoice-item.js